import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useStoreActions } from '~/contexts';
import { QueryKeys } from '../queryKeys';
import { useQueryState } from '../useQueryState';
const draftQueryKey = (draftId)=>[
        QueryKeys.Draft,
        draftId
    ];
export const useDraft = function useDraft() {
    let { draftId, refreshOnHookMount } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    const { data, isLoading, isBackgroundLoading, isFetching, error, refresh } = useQueryState({
        queryKey: draftQueryKey(draftId),
        queryFn: ()=>api.draft.getById(draftId),
        enabled: !!draftId,
        refreshOnHookMount
    });
    const forceRefetch = useCallback(async (idOverride)=>{
        const id = idOverride !== null && idOverride !== void 0 ? idOverride : draftId;
        if (id == null) return;
        const fresh = await api.draft.getById(id);
        queryClient.setQueryData(draftQueryKey(id), fresh);
    }, [
        api,
        queryClient,
        draftId
    ]);
    return {
        draft: data,
        isLoading,
        isBackgroundLoading,
        isFetching,
        error,
        refresh,
        forceRefetch
    };
};
